/**
 * Export `Ballon` type.
 */

export type Balloon = {
  image: string;
  name: string;
  size: number;
  url: string;
};

/**
 * Export `balloons`.
 */

export const balloons: Balloon[] = [
  {
    image: '/static/images/balloons/helium-30-ballons.png',
    name: 'Balloon Time Standard',
    size: 30,
    url: 'https://www.balloontime.com/our-products/9-5-helium-tank'
  },
  {
    image: '/static/images/balloons/helium-30-ballons-kit.png',
    name: 'Balloon Time Standard Kit',
    size: 30,
    url: 'https://www.balloontime.com/our-products/9-5-helium-kit'
  },
  {
    image: '/static/images/balloons/helium-50-ballons.png',
    name: 'Balloon Time Jumbo',
    size: 50,
    url: 'https://www.balloontime.com/our-products/jumbo-12-helium-tank'
  },
  {
    image: '/static/images/balloons/helium-50-ballons-kit.png',
    name: 'Balloon Time Jumbo Kit',
    size: 50,
    url: 'https://www.balloontime.com/our-products/jumbo-12-helium-kit'
  }
];
